(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 function setup(root) {
  const title = root.querySelector('h1');
  if (!title || title.dataset.titleMotionReady) return;
  title.dataset.titleMotionReady = 'true';
  let animation;
  function reveal() {
   if (reduced.matches || !title.animate) return;
   animation = title.animate(
    [{ opacity: .8, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }],
    { duration: 450, easing: 'cubic-bezier(.2,.7,.3,1)' }
   );
  }
  if ('IntersectionObserver' in window) {
   const observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); reveal(); }
   }, { threshold: .25 });
   observer.observe(title);
  } else reveal();
  reduced.addEventListener('change', () => { if (reduced.matches) animation?.cancel(); });
 }
 document.querySelectorAll('.jasmin-product').forEach(setup);
 document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.jasmin-product').forEach(setup));
})();
